import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { X, FileText } from 'lucide-react';

const API = process.env.REACT_APP_API_BASE_URL;
const fmt = (d) => {
  if (!d) return '--';
  const x = new Date(d);
  return `${String(x.getDate()).padStart(2,'0')}-${String(x.getMonth()+1).padStart(2,'0')}-${x.getFullYear()}`;
};
const th = { padding: '12px', textAlign: 'left', background: '#f8fafc', borderBottom: '1px solid #e2e8f0', whiteSpace: 'nowrap', position: 'sticky', top: 0, zIndex: 5 };
const td = { padding: '12px', borderBottom: '1px solid #f1f5f9', verticalAlign: 'middle' };

const inputStyle = {
  width: '100%', minWidth: '160px', padding: '10px 12px', borderRadius: '6px',
  border: '1px solid #cbd5e1', background: '#f8fafc', color: '#1e293b',
  fontSize: '14px', boxSizing: 'border-box', outline: 'none', fontFamily: 'inherit'
};
const selectStyle = {
  minWidth: '90px', padding: '10px 12px', borderRadius: '6px',
  border: '1px solid #cbd5e1', background: 'white', color: '#334155',
  fontSize: '14px', fontWeight: 600, cursor: 'pointer', outline: 'none'
};
const selectColor = (v) => v === 'Yes'
  ? { backgroundColor: '#f0fdf4', color: '#15803d' }
  : v === 'No'
    ? { backgroundColor: '#fef2f2', color: '#b91c1c' }
    : {};

export default function ExistingCandidatesModal({ job, partnerId, onSelectCandidate, onClose }) {
  const [data, setData] = useState({ job: null, keywords: [], candidates: [] });
  const [loading, setLoading] = useState(true);
  const [opening, setOpening] = useState(null);
  const jobId = job.id || job._id;

  const openSubmit = async (c) => {
    try {
      setOpening(c.email);
      const { data: res } = await axios.get(`${API}/api/candidates/existing-prefill/${c.candidateId}`);
      onSelectCandidate({ ...res.prefill, resumeUrl: res.resumeUrl });
    } catch {
      alert('Failed to load candidate details');
    } finally {
      setOpening(null);
    }
  };

  useEffect(() => {
    axios.get(`${API}/api/candidates/existing-for-job/${jobId}`, { params: partnerId ? { partnerId } : {} })
      .then(r => setData(r.data))
      .catch(() => alert('Failed to load existing candidates'))
      .finally(() => setLoading(false));
  }, [jobId, partnerId]);

  const save = async (cand, field, value) => {
    setData(prev => ({ ...prev, candidates: prev.candidates.map(c => c.email === cand.email ? { ...c, [field]: value } : c) }));
    try {
      await axios.put(`${API}/api/candidates/existing-tracker`, { jobId, candidateEmail: cand.email, [field]: value });
    } catch { alert('Failed to save'); }
  };

  const resumeLink = (url) => `${API}/api/candidates/view-file?url=${encodeURIComponent(url)}`;
  const j = data.job || {};

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.6)', backdropFilter: 'blur(4px)', zIndex: 10000, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <style>{`
        .ec-input:focus, .ec-select:focus { border-color: #2563eb !important; box-shadow: 0 0 0 3px rgba(37,99,235,0.12); background: #fff !important; }
        .ec-input::placeholder { color: #94a3b8; }
      `}</style>
      <div style={{ background: '#fff', width: '95vw', maxHeight: '90vh', borderRadius: 12, display: 'flex', flexDirection: 'column', boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)' }}>
        <div style={{ padding: '16px 20px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between' }}>
          <div>
        <h3 style={{ margin: 0 }}>
            Existing Candidates – {job.role}
            {!loading && (
            <span style={{ marginLeft: 10, fontSize: 13, fontWeight: 600, background: '#eff6ff', color: '#2563eb', padding: '3px 10px', borderRadius: 12 }}>
                Total: {data.candidates.length}
            </span>
            )}
        </h3>
        <small style={{ color: '#64748b' }}>Matched on: {data.keywords.join(', ') || '--'}</small>
        </div>
          <button onClick={onClose} style={{ border: 'none', background: 'none', cursor: 'pointer' }}><X size={20} /></button>
        </div>

        <div style={{ overflow: 'auto', flex: 1 }}>
          <table style={{ width: '100%', minWidth: 1500, borderCollapse: 'separate', borderSpacing: 0, fontSize: 14 }}>
            <thead>
              <tr>
                {['Date','Beeline ID','Role Name','Location','Candidate','Job Name','Email','Phone','Resume','Calling','Remarks','Holding Period']
                  .map(h => <th key={h} style={th}>{h}</th>)}
              </tr>
            </thead>
            <tbody>
              {loading ? <tr><td colSpan={12} style={{ ...td, textAlign: 'center' }}>Loading…</td></tr>
              : data.candidates.length === 0 ? <tr><td colSpan={12} style={{ ...td, textAlign: 'center', color: '#94a3b8' }}>No matching candidates in database.</td></tr>
              : data.candidates.map(c => (
                <tr key={c.email}>
                  <td style={td}>{fmt(c.uploadedAt)}</td>
                  <td style={td}>{j.beelineId || j.requestId || '--'}</td>
                  <td style={td}>{j.role}</td>
                  <td style={td}>{j.location || '--'}</td>
                  <td style={{ ...td, fontWeight: 600 }}>
  {onSelectCandidate ? (
    <button onClick={() => openSubmit(c)} disabled={opening === c.email}
      title="Submit this candidate to Beeline"
      style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: '#2563eb', fontWeight: 600, fontSize: 14, textDecoration: 'underline', textAlign: 'left' }}>
      {opening === c.email ? 'Loading…' : c.candidateName}
    </button>
  ) : c.candidateName}
</td>
                  <td style={td}>{c.candidateJobRole || '--'}</td>
                  <td style={td}>{c.email}</td>
                  <td style={td}>{c.phone || '--'}</td>
                  <td style={td}>{c.resumeUrl
                    ? <a href={resumeLink(c.resumeUrl)} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 5, color: '#2563eb' }}><FileText size={16} /> PDF</a> : '--'}</td>
                  <td style={td}>
                    <select className="ec-select" value={c.calling || ''} onChange={e => save(c, 'calling', e.target.value)}
                      style={{ ...selectStyle, ...selectColor(c.calling) }}>
                      <option value="">--</option><option>Yes</option><option>No</option>
                    </select>
                  </td>
                  <td style={{ ...td, minWidth: 220 }}>
                    <input className="ec-input" style={inputStyle} defaultValue={c.remarks} placeholder="Remarks…"
                      onBlur={e => e.target.value !== (c.remarks || '') && save(c, 'remarks', e.target.value)} />
                  </td>
                  <td style={{ ...td, minWidth: 180 }}>
                    <input className="ec-input" style={inputStyle} defaultValue={c.holdingPeriod} placeholder="e.g. 30 days"
                      onBlur={e => e.target.value !== (c.holdingPeriod || '') && save(c, 'holdingPeriod', e.target.value)} />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}